import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

if (getParameterByName("access_token") !== null) {
  var redirect = "/";
  var token = getParameterByName("access_token");
  localStorage.setItem("access_token", token);

  if (localStorage.getItem("redirect")) {
    redirect = localStorage.getItem("redirect");
  }
  window.location = redirect;
} else if (!localStorage.getItem("access_token")) {
  window.location = `${process.env.REACT_APP_AUTH_ENDPOINT}/login/${process.env.REACT_APP_JWT_CLIENT_ID}`;
} else {
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <App />
      </Router>
    </React.StrictMode>,
    document.getElementById("root")
  );
}
